import { render } from "./Home.vue?vue&type=template&id=adb63d90&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=adb63d90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-adb63d90"

export default script